import { useEffect, useState } from 'react';

//next
// import Link from 'next/link';
import Image from 'next/image';
import { useRouter } from "next/router";

import styles from 'styles/components/texture.module.scss';

//material
// import Container from '@mui/material/Container';
// import Grid from '@mui/material/Grid';
// import Typography from '@mui/material/Typography';
// import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

//3rd party
import { isMobileOnly,isIOS } from "react-device-detect";
import { useTranslation } from 'react-i18next';
// import ReactPlayer from 'react-player';
import ReactPlayer from 'react-player/lazy'
import { motion } from "framer-motion";

//assets

const variants = {
  open: { opacity: 1, pointerEvents:'all' },
  closed: { opacity: 0, pointerEvents:'none' },
}

function Texturecomponent({width,height,caption,texture,imgtexture,videotexture,props,}){

  const {t} =  useTranslation();
  const {locale} = useRouter();
  const isMobile = isMobileOnly;

  // console.log(width,height)

  const [isOpenVideo, setIsOpenVideo] = useState(false);

  const playerOnPlay = () => {
    console.log("playerOnPlay")
    setIsOpenVideo(true)
  };
  const playerOnPuase = () => {
    console.log("playerOnPuase");
    setTimeout(() => {
      setplayerPlaying(false);
      setIsOpenVideo(false)
    }, 1000);
    
  };
  const playeyOnEnded = () => {
    console.log("playeyOnEnded");
    setplayerPlaying(false);
    setIsOpenVideo(false)
  };

  const [playerPlaying, setplayerPlaying] = useState(false);
  const btn_play = () => {
    setplayerPlaying(true);
    // setIsOpenVideo(isOpenVideo => !isOpenVideo)
  };

  const [videoW, setvideoW] = useState(width);
  const [videoH, setvideoH] = useState(height);
  useEffect(() => {
    if(isMobile){
      setvideoW(285)
      setvideoH(157)
    }
  }, []);

   //image blur start
   const shimmer = (w, h) => `
   <svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
     <defs>
       <linearGradient id="g">
         <stop stop-color="#333" offset="20%" />
         <stop stop-color="#222" offset="50%" />
         <stop stop-color="#333" offset="70%" />
       </linearGradient>
     </defs>
     <rect width="${w}" height="${h}" fill="#333" />
     <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
     <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
   </svg>`
   const toBase64 = (str) =>
     typeof window === 'undefined'
       ? Buffer.from(str).toString('base64')
       : window.btoa(str)
   //image blur end

  return(
    <>
      <div className={`${styles.content_wr} content_wr`} >

        <div className={`${styles.img_wr} img_caption`} >
          {/* <Image placeholder="blur" blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(videoW, videoH))}`} src={`/assets/Pictures/${texture}.jpg`} width={videoW} height={videoH} layout="responsive" className="img_fluid" alt={caption} />  */}
          <Image placeholder="blur" src={imgtexture} width={videoW} height={videoH} layout="responsive" className="img_fluid" alt={caption} /> 
          <figcaption className={`${styles.img_caption} img_caption`}>{caption}</figcaption>
        </div>
        
        <div className={`${styles.context_wr} context_wr`}>
          <div className={`${styles.context} context`}>
            <IconButton aria-label="play" className={`${styles.btn_play} btn_play`} onClick={btn_play}>
              <PlayArrowIcon fontSize="inherit" />
            </IconButton>
          </div>
        </div>

        <motion.div className={`${styles.motion_div} motion_div`} 
          animate={isOpenVideo ? "open" : "closed"}
          variants={variants}
        >
          <ReactPlayer
            onPlay={playerOnPlay}
            // onPause={playerOnPuase}
            onEnded={playeyOnEnded}
            playing={playerPlaying}
            playsinline={true}
            controls={true}
            className={`${styles.react_player} react_player`}
            url={`/assets/Pictures/${texture}.mp4`}
            // url={videotexture}
            width='100%'
            height='100%'
            config={{
              youtube: {
                playerVars: { showinfo: 0 }
              },
            }}
          />
        </motion.div>
      </div>
    </>
  )
}
export default Texturecomponent;